import React from "react";
import { Link } from "react-router-dom";
import BusinessOrdersTableComponent from "../../components/orders/BusinessOrdersTableComponent";
import useAccount from "../../hooks/useAccount";
import "../../styles/pages/dashboard/businessDashboardPageComponent.scss";
import "../../styles/pages/dashboard/adminDashboardPageComponent.scss";

const BusinessDashboardPageComponent = () => {
  const { userInfo } = useAccount();
  const firstName = userInfo?.businessCustomer?.firstName;

  const quickActions = [
    {
      title: "היסטוריית הזמנות",
      link: "orders",
      description: "צפייה בכל ההזמנות שלך",
      icon: "fa-solid fa-clock-rotate-left",
    },
    {
      title: "קטלוג מוצרים",
      link: "/items",
      description: "עיון בכל המוצרים הזמינים",
      icon: "fa-solid fa-box-open",
    },
    {
      title: "עגלת קניות",
      link: "/shoppingCart",
      description: "השלם הזמנה שבהכנה",
      icon: "fa-solid fa-cart-shopping",
    },
  ];

  return (
    <div className="businessDashboardContainer">
      <div className="businessDashboardHeader">
        <h1 className="businessDashboardWelcome">
          ברוך הבא{firstName ? `, ${firstName}` : ""}
        </h1>
        <p className="businessDashboardSubtitle">ניהול הזמנות וצפייה בקטלוג</p>
        <div className="businessDashboardDivider" />
      </div>

      <div className="businessDashboardQuickActions">
        {quickActions.map((item, index) => (
          <Link key={index} to={item.link} className="adminDashboardCard">
            <div className="adminDashboardCardIcon">
              <i className={item.icon}></i>
            </div>
            <div className="adminDashboardCardContent">
              <h3 className="adminDashboardCardTitle">{item.title}</h3>
              <p className="adminDashboardCardDescription">{item.description}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="businessDashboardSection">
        <h2 className="businessDashboardSectionTitle">הזמנות אחרונות</h2>
        <BusinessOrdersTableComponent />
      </div>
    </div>
  );
};

export default BusinessDashboardPageComponent;
